import LoginPage from '../views/Auth/LoginPage'
import SSOLoginPage from '../views/Auth/SSOLoginPage'
import ResetPasswordPage from '../views/Auth/ResetPasswordPage'
import NewPasswordPage from '../views/Auth/NewPasswordPage'
import MFALoginPage from '../views/Auth/MFALoginPage'
import IntegrationCallbackPage from '../views/Integrations/IntegrationCallbackPage'
import SlackLandingPage from '../views/Integrations/SlackLandingPage'
import { OAuthConsentPage } from '../views/OAuth/OAuthConsentPage'

export const publicRoutes = [
  { path: '/login', Component: LoginPage },
  { path: '/login_sso', Component: SSOLoginPage },
  { path: '/login_mfa', Component: MFALoginPage },
  { path: '/reset_password', Component: ResetPasswordPage },
  { path: '/temporary_links/:temporaryLink', Component: NewPasswordPage },
  { path: '/integrations/slack', Component: SlackLandingPage },
  { path: '/integrations/:provider/callback', Component: IntegrationCallbackPage },
  { path: '/oauth/consent', Component: OAuthConsentPage },
]
